import { ApiResult } from "~/models/ApiResult";
import { type AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import {
  type GetAdvertisementAllRequest,
  GetAdvertisementAllResponse,
  GetAdvertisementByIdRequest,
  GetAdvertisementByIdResponse,
  MyAdvertisementByIdRequest,
  MyAdvertisementByIdResponse,
  GetIncomingProjectDetailResponse,
  GetLogCountResponse,
  GetAdvertisementLogByIdRequest,
  GetAdvertisementLogByIdResponse,
  GetPastAdvertisementLogByIdRequest,
  GetPastAdvertisementLogByIdResponse,
  GetAdvertisementPartsByIdRequest,
  GetAdvertisementPartsByIdResponse,
  IlanaCikarNoPartnerRequest,
  OnAlimaSorRequest,
  OnALimGuncelleRequest,
  BuyAdvertisementRequest,
  GetDepositInfoRequest,
  GetDepositInfoResponse,
  GetAdvertisementSoldedByIdResponse,
  GetPropertyForecastAllRequest,
  GetPropertyForecastAllResponse,
} from "~/models/AdvertisementModels";

import { GetFeatureAdvertisementRequest, FeatureAdvertisementResponse, AdvantageousPurchaseRequest, AdvantageousPurchaseResponse } from "~/models/FeatureAdvertisementModels";

export class AdvertisementService extends BaseService {
  constructor() {
    super("Advertisement");
  }
  GetAdvertisementList(query: GetAdvertisementAllRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementAllResponse>>>> {
    let queryString = '?';
    let prepend = '';

    // Sadece dolu alanları eklemek için kontrol
    if (query.pageNumber) {
      queryString += `${prepend}PageNumber=${query.pageNumber}`;
      prepend = '&';
    }
    if (query.pageSize) {
      queryString += `${prepend}PageSize=${query.pageSize}`;
      prepend = '&';
    }
    if (query.search) {
      queryString += `${prepend}Search=${encodeURIComponent(query.search)}`;
      prepend = '&';
    }
    if (query.provinceId) {
      console.log(query)
      queryString += `${prepend}ProvinceId=${query.provinceId}`;
      prepend = '&';
    }
    if (query.districtId) {
      queryString += `${prepend}DistrictId=${query.districtId}`;
      prepend = '&';
    }
    if (query.minRentalIncome) {
      queryString += `${prepend}MinRentalIncome=${query.minRentalIncome}`;
      prepend = '&';
    }
    if (query.minPrice) {
      queryString += `${prepend}MinPrice=${query.minPrice}`;
      prepend = '&';
    }
    if (query.maxPrice) {
      queryString += `${prepend}MaxPrice=${query.maxPrice}`;
      prepend = '&';
    }
    if (query.orderType) {
      queryString += `${prepend}OrderType=${query.orderType}`;
      prepend = '&';
    }
    if (query.productDeveloperId) {
      queryString += `${prepend}ProductDeveloperId=${query.productDeveloperId}`;
      prepend = '&';
    }
    if (query.rateOfPieceFilter) {
      const rateOfPieceFilter = Array.isArray(query.rateOfPieceFilter)
        ? query.rateOfPieceFilter
        : [query.rateOfPieceFilter];

      rateOfPieceFilter.forEach((value: number) => {
        queryString += `${prepend}RateOfPieceFilter=${value}`;
        prepend = '&';
      });
    }
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/List${queryString}`);
  }
  IncomingProjectGridList(query: GetAdvertisementAllRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementAllResponse>>>> {
    let queryString = '?';
    let prepend = '';

    // Sadece dolu alanları eklemek için kontrol
    if (query.pageNumber) {
      queryString += `${prepend}PageNumber=${query.pageNumber}`;
      prepend = '&';
    }
    if (query.pageSize) {
      queryString += `${prepend}PageSize=${query.pageSize}`;
      prepend = '&';
    }
    if (query.search) {
      queryString += `${prepend}Search=${encodeURIComponent(query.search)}`;
      prepend = '&';
    }
    if (query.provinceId) {
      queryString += `${prepend}ProvinceId=${query.provinceId}`;
      prepend = '&';
    }
    if (query.districtId) {
      queryString += `${prepend}DistrictId=${query.districtId}`;
      prepend = '&';
    }
    if (query.minRentalIncome) {
      queryString += `${prepend}MinRentalIncome=${query.minRentalIncome}`;
      prepend = '&';
    }
    if (query.minPrice) {
      queryString += `${prepend}MinPrice=${query.minPrice}`;
      prepend = '&';
    }
    if (query.maxPrice) {
      queryString += `${prepend}MaxPrice=${query.maxPrice}`;
      prepend = '&';
    }
    if (query.orderType) {
      queryString += `${prepend}OrderType=${query.orderType}`;
      prepend = '&';
    }
    if (query.productDeveloperId) {
      queryString += `${prepend}ProductDeveloperId=${query.productDeveloperId}`;
      prepend = '&';
    }
    if (query.rateOfPieceFilter) {
      const rateOfPieceFilter = Array.isArray(query.rateOfPieceFilter)
        ? query.rateOfPieceFilter
        : [query.rateOfPieceFilter];

      rateOfPieceFilter.forEach((value: number) => {
        queryString += `${prepend}RateOfPieceFilter=${value}`;
        prepend = '&';
      });
    }
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/IncomingProjectGridList${queryString}`);
  }
  //Satış bitti İlanları getir
  GetAdvertisementSoldedList(query: GetAdvertisementAllRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementAllResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/SoldList`, query);
  }
  GetAdvertisementSoldedById(query: GetAdvertisementByIdRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementSoldedByIdResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/SoldDetail`, query);
  }
  //Kiralandı İlanları getir
  GetAdvertisementRentedList(query: GetAdvertisementAllRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementAllResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/RentedList`, query);
  }
  GetAdvertisementRentedById(query: GetAdvertisementByIdRequest): Promise<AxiosResponse<ApiResult<Array<GetAdvertisementSoldedByIdResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/RentedDetail`, query);
  }

  //gelecek projedeki İlanları getir
  GetAdvertisementIncomingProjectList(query: GetFeatureAdvertisementRequest): Promise<AxiosResponse<ApiResult<Array<FeatureAdvertisementResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/IncomingProjectList`, query);
  }
  GetIncomingProjectById(query: GetAdvertisementByIdRequest): Promise<AxiosResponse<ApiResult<GetIncomingProjectDetailResponse>>> {
    return this.client.Get<ApiResult<GetIncomingProjectDetailResponse>>(`${this.baseUrl}/IncomingProjectDetail?advertisementId=${query.advertisementId}`);
  }

  GetAdvertisementById(query: GetAdvertisementByIdRequest): Promise<AxiosResponse<ApiResult<GetAdvertisementByIdResponse>>> {
    return this.client.Get<ApiResult<GetAdvertisementByIdResponse>>(`${this.baseUrl}/Detail?advertisementId=${query.advertisementId}`);
  }

  MyAdvertisementById(query: MyAdvertisementByIdRequest): Promise<AxiosResponse<ApiResult<MyAdvertisementByIdResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/MyAdvertisementById`, query);
  }
  GetLogCount(): Promise<AxiosResponse<ApiResult<Array<GetLogCountResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetLogCount`);
  }
  GetAdvertisementLogById(query: GetAdvertisementLogByIdRequest): Promise<AxiosResponse<ApiResult<GetAdvertisementLogByIdResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetAdvertisementLogById`, query)
  }
  GetPastAdvertisementLogById(query: GetPastAdvertisementLogByIdRequest): Promise<AxiosResponse<ApiResult<GetPastAdvertisementLogByIdResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetPastAdvertisementLogById`, query)
  }
  GetAdvertisementPartsById(query: GetAdvertisementPartsByIdRequest): Promise<AxiosResponse<ApiResult<GetAdvertisementPartsByIdResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/Parts`, query)
  }
  IlanaCikarNoPartner(body: IlanaCikarNoPartnerRequest): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/IlanaCikarNoPartner`, body)
  }
  OnAlimaSor(body: OnAlimaSorRequest): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/OnAlimaSor`, body)
  }
  OnALimGuncelle(body: OnALimGuncelleRequest): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/OnALimGuncelle`, body)
  }
  BuyAdvertisement(body: BuyAdvertisementRequest): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Buy`, body)
  }
  GetDepositInfo(query: GetDepositInfoRequest): Promise<AxiosResponse<ApiResult<GetDepositInfoResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/PaymentInfos`, query)
  }
  GetPropertyForecastAll(query: GetPropertyForecastAllRequest): Promise<AxiosResponse<ApiResult<GetPropertyForecastAllResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/GetPropertyForecastAll`, query);
  }
  GetAdvertisementAdvantageousPurchaseList(query: AdvantageousPurchaseRequest): Promise<AxiosResponse<ApiResult<AdvantageousPurchaseResponse>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/PreSaleAdvantageList`, query);
  }
}
